export default __webpack_public_path__ + "static/media/pickshare-mockup.408819ed.png";